type ViteEnv = ImportMeta & {
  env: {
    VITE_ENV: string;
    VITE_AUTHORITY: string;
    VITE_CLIENT_ID: string;
    VITE_REDIRECT_URI: string;
    VITE_BACKEND_URL: string;
    VITE_WEBSOCKET: string;
    VITE_REACT_APP_VERSION: string;
    VITE_API_KEY: string;
  };
};

export const config = {
  VITE_AUTHORITY: (import.meta as ViteEnv).env.VITE_AUTHORITY,
  VITE_CLIENT_ID: (import.meta as ViteEnv).env.VITE_CLIENT_ID,
  VITE_ENV: (import.meta as ViteEnv).env.VITE_ENV,
  VITE_REDIRECT_URI: (import.meta as ViteEnv).env.VITE_REDIRECT_URI,
  VITE_BACKEND_URL: (import.meta as ViteEnv).env.VITE_BACKEND_URL,
  VITE_WEBSOCKET: (import.meta as ViteEnv).env.VITE_WEBSOCKET,
  VITE_API_KEY: (import.meta as ViteEnv).env.VITE_API_KEY,
  VERSION: (import.meta as ViteEnv).env.VITE_REACT_APP_VERSION
};
